// extracted by mini-css-extract-plugin
export default {"modalHeader":"ModalWrapper_modalHeader__EP1Tl"};